// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"18253cc9","498":"556d216c","513":"5dc9afc1"}[chunkId] + ".chunk.js";
};